import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-big-calendar/lib/css/react-big-calendar.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-big-calendar/lib/addons/dragAndDrop/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-big-calendar/lib/addons/dragAndDrop/styles.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/StoreProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/toast.provider.jsx");
